import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { BadgesModule } from '@shared/core/components/badges';
import { MaterialModule } from '@shared/core/modules/material';
import { IconModule } from '@shared/core/components/icon';
import { LoadersModule } from '@shared/core/components/loaders';

import { BtnComponent } from './btn.shared.component';

@NgModule({
    declarations: [
        BtnComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        BadgesModule,
        MaterialModule,
        IconModule,
        LoadersModule,
    ],
    exports: [
        BtnComponent,
    ],
    providers: [],
})
export class BtnModule { }
